window.FazendaRP = window.FazendaRP || {};

window.FazendaRP.renderHeader = function (container) {
    container.innerHTML = `
        <div class="app-header">
            <div class="brand-logo">
                <i class="fas fa-leaf"></i>
                <span>Fazenda RP</span>
            </div>
            
            <div class="header-actions">
                <div class="user-info" style="display: flex; align-items: center; gap: 10px;">
                    <span style="font-size: 0.9em; color: var(--text-muted);">Fazenda Rio do Peixe</span>
                    <div class="user-avatar" title="Perfil">FR</div>
                </div>
            </div>
        </div>
    `;
    container.classList.add('rendered');
};
